import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils.js";
const Popover = React.createContext({
  open: false,
  setOpen: () => {
  }
});
const PopoverRoot = ({
  children,
  open: controlledOpen,
  onOpenChange
}) => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const open = controlledOpen !== void 0 ? controlledOpen : internalOpen;
  const setOpen = onOpenChange || setInternalOpen;
  return /* @__PURE__ */ jsx(Popover.Provider, { value: { open, setOpen }, children });
};
const PopoverTrigger = React.forwardRef(({ className, children, onClick, ...props }, ref) => {
  const { open, setOpen } = React.useContext(Popover);
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
    onClick?.(e);
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      ref,
      type: "button",
      className,
      onClick: handleClick,
      ...props,
      children
    }
  );
});
PopoverTrigger.displayName = "PopoverTrigger";
const PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, children, ...props }, _ref) => {
  const { open, setOpen } = React.useContext(Popover);
  const contentRef = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (contentRef.current && !contentRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    }
  }, [open, setOpen]);
  if (!open) {
    return null;
  }
  const alignmentClasses = {
    start: "left-0",
    center: "left-1/2 -translate-x-1/2",
    end: "right-0"
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: contentRef,
      className: cn(
        "absolute w-72 rounded-md border bg-white dark:bg-neutral-800 p-4 text-neutral-900 dark:text-neutral-100 shadow-lg outline-none",
        "animate-in fade-in-0 zoom-in-95",
        alignmentClasses[align],
        className
      ),
      style: { marginTop: sideOffset, zIndex: 9999 },
      ...props,
      children
    }
  );
});
PopoverContent.displayName = "PopoverContent";
export {
  PopoverRoot as Popover,
  PopoverContent,
  PopoverTrigger
};
//# sourceMappingURL=popover.js.map
